import axios from 'axios';

const base = () => process.env.VUE_APP_NEW_API_URL;

export default {
  // Short-lived signed URL returning the docket as ESC/POS bytes. Handed to the
  // local agent, which fetches it and writes it to the printer.
  escposUrl(orderId) {
    return axios.get(`${base()}/staff/job-docket-escpos-url/${orderId}`);
  },

  // Public: a download link in the browser cannot carry a bearer token.
  installerUrl(platform) {
    return `${base()}/print-agent/installer/${platform}`;
  },
};
